import BrandEntry from './features/brand/BrandEntry';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'rsuite/dist/rsuite.min.css';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import CreateOrder from './pages/Rider/Order/Create';
import LineCallback from './pages/LineCallback';
import OrderIndex from './pages/Rider/Order/Index';
import RiderIndex from './pages/Rider/Index';
import FlightInfoPage from './pages/FlightInfo';
import PageNotFoundPage from './pages/PageNotFound';
import RiderOrderDetail from './pages/Rider/Order/Detail';
import Login from './pages/Login';
import LiffCallback from './pages/LiffCallback';
import ECPayResultPage from './pages/Rider/Payment/ECPayResult';
// import NavigationHeader from './components/NavigationHeader';
import HomeUberTaxi from './pages/HomeUberTaxi';
// import FooterUberTaxi from './components/FooterUberTaxi';
import EmailVerificationPage from './pages/EmailVerificationPage';
import UserProfile from './pages/UserProfile';
import ECPayCreditCard from './pages/Rider/Payment/ECPayCreditCard';
import ProtectedRoute from './components/ProtectedRoute';
import PrivacyPolicy from "./pages/privacy";
import RegisterAccount from "./pages/RegisterAccount";
import BlindCreate from "./pages/Rider/Order/BlindCreate";
import DriverAppDownload from './pages/DriverAppDownload';

function App() {
  // Admin routes removed; isAdminRoute always false
  // const isAdminRoute = false;

  return (
    <div className="App">

      {/* {!liff.isInClient() && <NavigationHeader isAdminRoute={isAdminRoute} />} */}

      <BrandEntry><Routes>
        <Route>
          <Route path="/" element={<HomeUberTaxi />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<RegisterAccount />} />
          <Route path="/flight" element={<FlightInfoPage />} />
          <Route path="/line/:teamCode/callback" element={<LineCallback />} />
          <Route path="/line/:teamCode/liffcallback" element={<LiffCallback />} />
          <Route path="profile" element={<UserProfile />} />
          <Route path="email-verification" element={<EmailVerificationPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/driver-app" element={<DriverAppDownload />} />

          <Route path="/rider" element={<ProtectedRoute />}>
            <Route index element={<RiderIndex />} />
            <Route path="order" element={<OrderIndex />} />
            <Route path='order/create' element={<CreateOrder />} />
            <Route path='order/blind-create' element={<BlindCreate />} />
            <Route path="order/:orderId" element={<RiderOrderDetail />} />
            <Route path="order/:orderId/payment/ecpay/credit-card" element={<ECPayCreditCard />} />
            <Route path="order/payment/ecpay/result" element={<ECPayResultPage />} />
          </Route>


        </Route>

        <Route
          path="*"
          element={<PageNotFoundPage />}
        />
      </Routes></BrandEntry>

      {/* {!isAdminRoute && <FooterUberTaxi />} */}
    </div >
  );
}

export default App;
